import {
  map
} from 'lodash'

const interval = () => {
  const values = [5, 6, 10, 12, 15, 20, 30, 45, 60, 90, 120]

  return map(values, (value) => {
    return {
      id: value,
      label: value
    }
  })
}

export default () => ({
  entity: 'rule',
  entities: 'rules',
  rules: [],
  rule: {
    agenda_id: null,
    interval: null,
    periodicity: 'weekley',
    sunday: false,
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    time_start: null,
    time_end: null,
    time_start_two: null,
    time_end_two: null,
    valid_to_start: null,
    valid_to_end: null,
    active: true,
    published: false
  },
  intervalOptions: interval(),
  activeOptions: [{
    id: true,
    label: 'Ativo'
  },
  {
    id: false,
    label: 'Inativo'
  }
  ],
  // never use prefix v1.
  prefixRouter: 'professional.agenda.rules'
})



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/resources/data.js